import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Translation resources
const resources = {
  en: {
    translation: {
      attributes: {
        // Service attributes
        'has_onsite_services': 'Onsite Services',
        'offers_online_estimates': 'Online Estimates',
        'has_service_repair': 'Service & Repair',
        'has_service_assembly': 'Assembly Service',
        'has_service_installation': 'Installation Service',
        'has_white_glove_service': 'White Glove Service',
        'requires_appointments': 'Requires Appointments',
        
        // Delivery & Shopping
        'has_delivery': 'Delivery',
        'has_delivery_same_day': 'Same Day Delivery',
        'has_curbside_pickup': 'Curbside Pickup',
        'has_in_store_pickup': 'In-Store Pickup',
        'has_in_store_shopping': 'In-Store Shopping',
        
        // Accessibility
        'has_wheelchair_accessible_entrance': 'Wheelchair Accessible Entrance',
        'has_wheelchair_accessible_seating': 'Wheelchair Accessible Seating',
        'has_wheelchair_accessible_parking': 'Wheelchair Accessible Parking',
        'has_wheelchair_accessible_restroom': 'Wheelchair Accessible Restroom',
        'has_hearing_loop': 'Hearing Loop',
        'has_assisted_listening_devices': 'Assisted Listening Devices',
        
        // Parking
        'has_onsite_parking': 'Onsite Parking',
        'has_parking_street_free': 'Free Street Parking',
        'has_parking_street_paid': 'Paid Street Parking',
        'has_parking_lot_free': 'Free Parking Lot',
        'has_parking_lot_paid': 'Paid Parking Lot',
        'has_parking_garage_free': 'Free Parking Garage',
        'has_parking_garage_paid': 'Paid Parking Garage',
        
        // Payment Methods
        'pay_credit_card': 'Credit Card',
        'pay_debit_card': 'Debit Card',
        'pay_mobile_nfc': 'Mobile NFC Payment',
        'pay_check': 'Check Payment',
        'requires_cash_only': 'Cash Only',
        
        // Credit Card Types
        'pay_credit_card_types_accepted': 'Accepted Credit Card Types',
        'visa': 'Visa',
        'mastercard': 'Mastercard',
        'american_express': 'American Express',
        'diners_club': 'Diners Club',
        'jcb': 'JCB',
        'discover': 'Discover',
        'china_union_pay': 'China Union Pay',
        
        // Inclusivity
        'welcomes_lgbtq': 'LGBTQ+ Welcoming',
        'is_transgender_safespace': 'Transgender Safe Space',
        'has_restroom_unisex': 'Unisex Restroom',
        'is_owned_by_women': 'Women-Owned Business',
        
        // Languages
        'languages_spoken': 'Languages Spoken',
        'english_spoken': 'English',
        'german_spoken': 'German',
        'french_spoken': 'French',
        'spanish_spoken': 'Spanish',
        'italian_spoken': 'Italian',
        'portuguese_spoken': 'Portuguese',
        'arabic_spoken': 'Arabic',
        'mandarin_spoken': 'Mandarin',
        'cantonese_spoken': 'Cantonese',
        'russian_spoken': 'Russian',
        'polish_spoken': 'Polish',
        'ukrainian_spoken': 'Ukrainian',
        'hindi_spoken': 'Hindi',
        'korean_spoken': 'Korean',
        'vietnamese_spoken': 'Vietnamese',
        'filipino_spoken': 'Filipino',
        'romanian_spoken': 'Romanian',
        'haitian_creole_spoken': 'Haitian Creole',
        'american_sign_language_used': 'American Sign Language',
        
        // Wi-Fi
        'wi_fi': 'Wi-Fi',
        'free_wi_fi': 'Free Wi-Fi',
        'paid_wi_fi': 'Paid Wi-Fi',
        'no_wi_fi': 'No Wi-Fi',
        
        // Messaging
        'preferred_messaging_service': 'Preferred Messaging Service',
        'whatsapp': 'WhatsApp',
        'telegram': 'Telegram',
        'signal': 'Signal',
        
        // Social Media
        'url_youtube': 'YouTube',
        'url_instagram': 'Instagram',
        'url_facebook': 'Facebook',
        'url_twitter': 'Twitter',
        'url_linkedin': 'LinkedIn',
        'url_tiktok': 'TikTok',
        'url_pinterest': 'Pinterest'
      }
    }
  },
  de: {
    translation: {
      attributes: {
        'accepts_donations_during_crisis': 'Nimmt Spenden während der Krise an',
        'american_express': 'American Express',
        'american_sign_language_used': 'Amerikanische Gebärdensprache',
        'arabic_spoken': 'Arabisch',
        'cantonese_spoken': 'Kantonesisch',
        'china_union_pay': 'China Union Pay',
        'diners_club': 'Diners Club',
        'discover': 'Discover',
        'english_spoken': 'Englisch',
        'filipino_spoken': 'Filipino',
        'free_wi_fi': 'Kostenloses WLAN',
        'french_spoken': 'Französisch',
        'german_spoken': 'Deutsch',
        'haitian_creole_spoken': 'Haitianisches Kreol',
        'has_assisted_listening_devices': 'Hörhilfen',
        'has_auracast_broadcast_audio': 'Auracast Audio-Übertragung',
        'has_changing_tables': 'Wickeltische',
        'has_curbside_pickup': 'Abholung am Straßenrand',
        'has_delivery': 'Lieferservice',
        'has_delivery_same_day': 'Lieferung am selben Tag',
        'has_furniture_rental': 'Möbelverleih',
        'has_hearing_loop': 'Induktionsschleife',
        'has_in_store_pickup': 'Abholung im Geschäft',
        'has_in_store_shopping': 'Einkaufen im Geschäft',
        'has_kid_friendly_activities': 'Kinderfreundliche Aktivitäten',
        'has_lactation_space': 'Stillbereich',
        'has_onsite_parking': 'Parkplätze vor Ort',
        'has_onsite_services': 'Vor-Ort-Service',
        'has_parking_garage_free': 'Kostenlose Parkgarage',
        'has_parking_garage_paid': 'Kostenpflichtige Parkgarage',
        'has_parking_lot_free': 'Kostenloser Parkplatz',
        'has_parking_lot_paid': 'Kostenpflichtiger Parkplatz',
        'has_parking_street_free': 'Kostenlose Straßenparkplätze',
        'has_parking_street_paid': 'Kostenpflichtige Straßenparkplätze',
        'has_recycling_batteries': 'Batterien-Recycling',
        'has_recycling_clothing': 'Textil-Recycling',
        'has_recycling_electronics': 'Elektronik-Recycling',
        'has_recycling_glass_bottles': 'Glasflaschen-Recycling',
        'has_recycling_ink_cartridges': 'Tintenpatronen-Recycling',
        'has_recycling_light_bulbs': 'Glühbirnen-Recycling',
        'has_recycling_metal_cans': 'Metalldosen-Recycling',
        'has_recycling_plastic_bottles': 'Plastikflaschen-Recycling',
        'has_restroom': 'Toiletten',
        'has_restroom_unisex': 'Unisex-Toilette',
        'has_service_assembly': 'Montage-Service',
        'has_service_installation': 'Installations-Service',
        'has_service_repair': 'Service & Reparatur',
        'has_wheelchair_accessible_entrance': 'Rollstuhlgerechter Eingang',
        'has_wheelchair_accessible_parking': 'Rollstuhlgerechte Parkplätze',
        'has_wheelchair_accessible_restroom': 'Rollstuhlgerechte Toiletten',
        'has_wheelchair_accessible_seating': 'Rollstuhlgerechte Sitzplätze',
        'has_white_glove_service': 'Premium-Service',
        'hindi_spoken': 'Hindi',
        'is_owned_by_women': 'Frauengeführtes Unternehmen',
        'is_transgender_safespace': 'Transgender-sicherer Ort',
        'italian_spoken': 'Italienisch',
        'jcb': 'JCB',
        'korean_spoken': 'Koreanisch',
        'languages_spoken': 'Gesprochene Sprachen',
        'mandarin_spoken': 'Mandarin',
        'mastercard': 'Mastercard',
        'needs_volunteers_during_crisis': 'Benötigt Freiwillige während der Krise',
        'offers_employment_during_crisis': 'Bietet Arbeitsplätze während der Krise',
        'offers_free_legal_help_during_crisis': 'Bietet kostenlose Rechtshilfe während der Krise',
        'offers_free_products_services_during_crisis': 'Bietet kostenlose Produkte/Services während der Krise',
        'offers_online_appointments': 'Online-Terminbuchung',
        'offers_online_estimates': 'Online-Kostenvoranschläge',
        'offers_refuge_during_crisis': 'Bietet Zuflucht während der Krise',
        'offers_transportation_during_crisis': 'Bietet Transport während der Krise',
        'pay_check': 'Scheck',
        'pay_credit_card': 'Kreditkarte',
        'pay_credit_card_types_accepted': 'Akzeptierte Kreditkartentypen',
        'pay_debit_card': 'EC-Karte',
        'pay_mobile_nfc': 'Mobiles NFC-Payment',
        'polish_spoken': 'Polnisch',
        'portuguese_spoken': 'Portugiesisch',
        'preferred_messaging_service': 'Bevorzugter Messaging-Dienst',
        'requires_appointments': 'Terminvereinbarung erforderlich',
        'requires_cash_only': 'Nur Bargeld',
        'romanian_spoken': 'Rumänisch',
        'russian_spoken': 'Russisch',
        'sells_goods_used': 'Verkauft gebrauchte Waren',
        'spanish_spoken': 'Spanisch',
        'text_messaging': 'SMS',
        'ukrainian_spoken': 'Ukrainisch',
        'url_appointment': 'Terminbuchung',
        'url_facebook': 'Facebook',
        'url_instagram': 'Instagram',
        'url_linkedin': 'LinkedIn',
        'url_pinterest': 'Pinterest',
        'url_text_messaging': 'SMS-Link',
        'url_tiktok': 'TikTok',
        'url_twitter': 'Twitter',
        'url_whatsapp': 'Whatsapp',
        'url_youtube': 'YouTube',
        'vietnamese_spoken': 'Vietnamesisch',
        'visa': 'Visa',
        'welcomes_lgbtq': 'LGBTQ+ freundlich',
        'whatsapp': 'WhatsApp',
        'wi_fi': 'WLAN'
      }
    }
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'de',
    lng: 'de', // Force German
    
    keySeparator: '.',
    
    interpolation: {
      escapeValue: false
    },
    
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage']
    }
  });

export default i18n;